import request from "@/utils/request";

// 获取支出合同
export function getContractList(param) {
    return request({
        url: '/system/contract/queryPaymentContract',
        method: 'get',
        params: param
    })
}